import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Label,
    Button,
    Collapse,
    Table,
    Tooltip,
    Badge
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import moment from 'moment'

import apiResponse from '../../../../../services/apiResponse'

import CreateBloc from './../Blocs/CreateBloc'

class EstimationCPNS extends Component {
    
    createBloc = new CreateBloc();
    queryParams = new URLSearchParams(window.location.search)

    constructor(props) {
        super(props)
        this.state = {
            dataForm: null,
            projection: null
        }
    }

    componentDidMount() {
        this.createBloc.getProjectionChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            projection: response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.createBloc.fetchGetProjection({uuid: this.props.uuid })
    }

    componentWillUnmount() {
        this.createBloc.getProjectionChannel?.unsubscribe()
    }

    render() {
      return (
        <Card className="">
            <CardBody>
                <CardTitle>Estimasi Kebutuhan CPNS</CardTitle>
                <CardSubtitle className="mb-3">
                    Periode : {this.props.periodMonth} {this.props.periodYear}
                </CardSubtitle>
                <hr />

                <div className="accordion" id="accordionExample">
                    <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                        <button className="accordion-button" type="button"
                            onClick={() => {
                                this.setState({
                                    col1 : !this.state.col1
                                })
                            }}
                            style={{ cursor: "pointer" }}>
                            Proyeksi Pensiun : {this.state.projection?.pension.total}
                        </button>
                    </h2>
                    <Collapse id="collapseOne" className="accordion-collapse" isOpen={this.state.col1}>
                        <div className="accordion-body">
                            <div className="table-responsive">
                                <Table className="table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>Posisi</th>
                                            <th>Jumlah</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        this.state.projection?.pension.total > 0 ?
                                            this.state.projection?.pension.result.map((val, i) => {
                                                return (
                                                    <tr key={`pensiun-${i}`}>
                                                        <td>{++i}</td>
                                                        <td>{val.position_name}</td>
                                                        <td>{val.count_pension}</td>
                                                    </tr>
                                                )
                                            })
                                        :
                                        <tr>
                                            <td colSpan="3" className="text-center">Tidak Ada Data</td>
                                        </tr>
                                    }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </Collapse>
                    </div>
                    <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                        <button className="accordion-button collapsed" type="button"
                            onClick={() => {
                                this.setState({
                                    col2 : !this.state.col2
                                })
                            }}
                            style={{ cursor: "pointer" }}>
                            Analisis Beban Kerja : {this.state.projection?.position.total}
                        </button>
                    </h2>
                    <Collapse id="collapseTwo" className="accordion-collapse" isOpen={this.state.col2}>
                        <div className="accordion-body">
                            <div className="table-responsive">
                                <Table className="table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>Posisi</th>
                                            <th>Jumlah</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        this.state.projection?.position.total > 0 ?
                                            this.state.projection?.position.result.map((val, i) => {
                                                return (
                                                    <tr key={`position-${i}`}>
                                                        <td>{++i}</td>
                                                        <td>{val.position_mapping_position_name}</td>
                                                        <td>{val.total_abk}</td>
                                                    </tr>
                                                )
                                            })
                                        :
                                        <tr>
                                            <td colSpan="3" className="text-center">Tidak Ada Data</td>
                                        </tr>
                                    }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </Collapse>
                    </div>
                </div>
                

                <hr />
            </CardBody>
        </Card>
      );
    }
}


export default EstimationCPNS;